import { render, staticRenderFns } from "./PK02624.vue?vue&type=template&id=2e678b36&scoped=true&"
import script from "./PK02624.vue?vue&type=script&lang=js&"
export * from "./PK02624.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e678b36",
  null
  
)

export default component.exports